import data from './salesRegionMapping.json'

export const salesRegionSuggestions = Array.from(new Set(data.map(x => x.salesRegion)))
    .sort()
    .map(x => ({value: x, label: x}))

/** Map countryToSalesRegionMapping.set(country, sales region) */
export const countryToSalesRegionMapping = new Map(data.map(x => [x.country, x.salesRegion]))
